import { Box } from "@mui/material";
import { FunctionComponent as F, useRef, useEffect, useState } from "react";
import SpielsTable from "../Refs/SpielsTable";
import { IValue } from "../Refs/RefsTable";




interface IProps
{
  record: IValue
}

const styles = {
  width: '100%',
  frameBorder: '0',
  scrolling: 'no',
  border: 'none',
  overflow: 'hidden' };

const Telegram: F<IProps> = (props: IProps) =>
{
  const ref = useRef<null | HTMLIFrameElement>(null);

  const [height, setHeight] = useState(200);

  const handleMessage = ({ data, source }: { data: string, source: MessageEventSource | null }) =>
  {
    if(!data || typeof data !== 'string' || source !== ref.current?.contentWindow)
      return;

    const action = JSON.parse(data);

    if(action.event === 'resize' && action.height)
      setHeight(action.height);
  };

  useEffect(() =>
  {
    window.addEventListener('message', handleMessage);

    return () => window.removeEventListener('message', handleMessage);
  }, []);

  if(!props.record.url)
    return <></>;

  return (
    <Box sx={{ display: 'flex' }}>
      <Box sx={{ display: 'flex' }}>
        <SpielsTable record={props.record} showInverseTimestamps={true}/>
      </Box>
      <Box sx={{ display: 'flex', textAlign: 'right' }}>
        <iframe
          ref={ref}
          src={props.record.url + '?embed=1'}
          style={styles}
          height={height} />
      </Box>
    </Box>);
};


export default Telegram;
